import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import RoomOccupancySupportDataViewer from './RoomOccupancySupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.RoomOccupancyEventsDataViewer' )

export default {
  id : 'ps.dataViewers.RoomOccupancyEventsDataViewer',
  type : 'ps.RoomOccupancyEvents',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : 'GroupDataViewer', objectType : 'room' },
  createSettings : ( props ) => {
    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          RoomOccupancySupportDataViewer.type, 
          RoomOccupancySupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ]
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
